<template>
  <div class='icon-arrow-double'>
    <svg xmlns="http://www.w3.org/2000/svg" width="11.927" height="10.791" viewBox="0 0 11.927 10.791">
      <path id="Path_38104" data-name="Path 38104" d="M-.73-4.875a.432.432,0,0,0,0-.609l-1.112-1.1a.424.424,0,0,0-.6,0L-6-3.033-9.556-6.589a.424.424,0,0,0-.6,0l-1.112,1.1a.432.432,0,0,0,0,.609L-6.3.087a.424.424,0,0,0,.6,0Z" transform="translate(11.715 -0.604) rotate(-90)" :fill="color"/>
      <path id="Path_38105" data-name="Path 38105" d="M-.73-4.875a.432.432,0,0,0,0-.609l-1.112-1.1a.424.424,0,0,0-.6,0L-6-3.033-9.556-6.589a.424.424,0,0,0-.6,0l-1.112,1.1a.432.432,0,0,0,0,.609L-6.3.087a.424.424,0,0,0,.6,0Z" transform="translate(6.715 -0.604) rotate(-90)" :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconArrowDouble',
  props: {
    color: {
      type: String,
      required: false,
      default: '#707070',
    },
  },
  components: {},
  data: () => ({
  }),
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang='scss' scoped>
</style>
